/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Open_TipInputs */

const en_pc_tut_open_tip = /** @type {(inputs: Pc_Tut_Open_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press ⌘K to search every tool and command by name. It is the fastest way to find anything.`)
};

const zh_pc_tut_open_tip = /** @type {(inputs: Pc_Tut_Open_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按 ⌘K 可按名称搜索所有工具和命令，这是找到功能最快的方式。`)
};

/**
* | output |
* | --- |
* | "Press ⌘K to search every tool and command by name. It is the fastest way to find anything." |
*
* @param {Pc_Tut_Open_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_open_tip = /** @type {((inputs?: Pc_Tut_Open_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Open_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_open_tip(inputs)
	return zh_pc_tut_open_tip(inputs)
});
export { pc_tut_open_tip as "pc.tut.open.tip" }